import React from 'react';
import { connect } from 'react-redux';
import { Footer, CreditInfo } from 'ui/lexus/containers';
import { ApplePayButton } from 'react-apple-pay-button';
import {
    isMobile,
    isIOS,
    scrollToFrame,
} from 'utils';

import {
    Checkbox,
    ModalPersonalDataProcessing,
    ModalAgreementOnReceivingEmails,
    ButtonOutlined,
} from 'ui/lexus/components';

import GooglePayButton from '@google-pay/button-react';
import { getApplePaySession as getApplePaySessionAction } from 'redux/applePay/actionCreators';
import {
    resetConsent as resetConsentAction,
    getConsent as getConsentAction,
    setConsent as setConsentAction,
} from 'redux/consent/actionCreators';
import { startGooglePay as startGooglePayAction } from '../../../../redux/googlePay/actionCreators';
import { PAY_STATUSES } from '../../../../settings';
import { Logo, Success } from '../../outlines';
import styles from './styles';
import { Loader } from '../../components';


const {
    CheckboxContainer,
    CheckboxWrapper,
    FrameLocker,
    FrameWrapper,
    MainContainer,
    MainBox,
    MainHeader,
    MainHeaderContainer,
    MainLogo,
    LogoImage,
    ContentWrapper,
    PayButtonContainer,
    StatusContainer,
    StatusTextContainer,
    StatusText,
    StatusSubText,
    GooglePayText,
    GooglePayContainer,
} = styles;

const canShowApplePayButton = false; // window.ApplePaySession;
const canShowGooglePayButton = false; /// !canShowApplePayButton

const getStatusComponents = (status) => {
    switch (status) {
        case PAY_STATUSES.remaining:
        case PAY_STATUSES.success: {
            return (
                {
                    icon: Success,
                    statusText: 'Спасибо, </br> оплата прошла успешно!',
                    subText: 'Информация о статусе платежа отправлена на указанный e-mail',
                    showRedirectButton: true,
                }
            );
        }
        case PAY_STATUSES.reserved: {
            return (
                {
                    icon: Success,
                    statusText: 'Спасибо, </br> Ваш заказ зарезервирован!',
                    subText: 'Информация о статусе платежа отправлена на указанный e-mail',
                    showRedirectButton: false,
                }
            );
        }
        default: {
            return {
                subText: 'Информация о статусе платежа отправлена на указанный e-mail',
            };
        }
    }
};

class MainBase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            personalDataProcessing: false,
            agreementOnReceivingEmails: false,
            blockFrame: true,
            errorOnAgreenment: false,
            modal: null,
        };
        this.iframe = React.createRef();
    }

    setCheckboxValue = (name, value) => {
        const types = {
            personalDataProcessing: 'processing_personal_data',
            agreementOnReceivingEmails: 'receive_advertising',
        };
        const type = types[name];
        if (type) {
            const url = document.location.href;
            const parsedUrl = new URL(url);
            const token = parsedUrl.pathname.replace(`${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '');
            this.props.setConsent(type, value, token);
        }
        this.setState({
            [name]: value,
        });
    };

    handleModalOpen = name => {
        this.setState({
            modal: name,
        });
    };

    handleModalClose = name => {
        if (this.state.modal === name) {
            this.setState({
                modal: null,
            });
        }
    };

    handleApplePayStart = () => {
        const {
            order: {
                amount,
            },
            orderId,
        } = this.props.frame.data;
        this.props.getApplePaySession({ amount, orderId });
    }

    componentDidMount() {
        if (this.iframe.current) {
            isIOS() ? scrollToFrame() : this.iframe.current.scrollIntoView();
        }

        this.props.resetConsent();

        if (!this.props.isStatus) {
            const url = document.location.href;
            const parsedUrl = new URL(url);
            const token = parsedUrl.pathname.replace(`${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '');
            this.props.getConsent(token);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.personalDataProcessing !== this.state.personalDataProcessing) {
            if (this.state.personalDataProcessing === false) {
                this.setState({
                    blockFrame: true,
                    errorOnAgreenment: true,
                });
            } else {
                this.setState({
                    blockFrame: false,
                    errorOnAgreenment: false,
                });
            }
        }
        const { processToData, receiveAdvertising } = this.props.consent;
        if ((
            processToData !== prevProps.consent.processToData
            && processToData !== null
        ) || (
            receiveAdvertising !== prevProps.consent.receiveAdvertising
            && receiveAdvertising !== null
        )) {
            this.setState({
                personalDataProcessing: processToData,
                agreementOnReceivingEmails: receiveAdvertising,
            });
        }
    }

    render() {
        const {
            dealerCenter,
            isLoadedFrame,
            isStatus,
            gotStatusPage,
            isLoadedStatus,
            googlePayIsLoading,
            frame: {
                data: {
                    order: {
                        amount,
                    } = {},
                    orderId = '',
                } = {},
            },
        } = this.props;

        const {
            frame: frameURL,
            order,
            order: {
                merchantOrderNumber,
            } = {},
            status,
            statusDescriprion,
        } = isStatus ? this.props.status.data : this.props.frame.data;

        const {
            modal, blockFrame, errorOnAgreenment,
        } = this.state;

        const {
            icon, statusText, subText, showRedirectButton,
        } = isStatus ? getStatusComponents(status) : {};

        const IS_TOP_WINDOW = window.top === window.self;
        const IS_MOBILE = isMobile();
        const { legalEntityResponseList } = dealerCenter.data;
        const creditInfoValue = Array.isArray(legalEntityResponseList) && legalEntityResponseList.length > 0 ? legalEntityResponseList[0] : {};
        const backButtonUrl = this.props?.status?.data?.dealerCenterSuccessUrl;
        return (
            <MainContainer>
                <MainHeaderContainer>
                    <MainHeader href="#">{isStatus ? 'Информация о заказе № ' : 'Оплата заказа № '} <span>{merchantOrderNumber}</span></MainHeader>
                    <MainLogo><LogoImage src={Logo} /></MainLogo>
                </MainHeaderContainer>

                <MainBox extraMarginBot={canShowApplePayButton} isStatus={isStatus}>
                    {frameURL && (
                        <FrameWrapper isMobile={IS_MOBILE}>
                            {IS_TOP_WINDOW && (
                                <iframe
                                    src={frameURL}
                                    frameBorder="no"
                                    title="Введите данные для совершения оплаты"
                                    scrolling="no"
                                    ref={this.iframe}
                                />
                            )}
                            <PayButtonContainer isApple={canShowApplePayButton}>
                                {canShowApplePayButton && (
                                    <div className="apple">
                                        <ApplePayButton
                                            onClick={this.handleApplePayStart}
                                            theme="black"
                                        >
                                        Оплатить с
                                        </ApplePayButton>
                                    </div>
                                )}
                                {canShowGooglePayButton && (
                                    <GooglePayContainer>
                                        <GooglePayButton
                                            environment={process.env.REACT_APP_GOOGLE_PAY_ENV}
                                            paymentRequest={{
                                                apiVersion: 2,
                                                apiVersionMinor: 0,
                                                callbackIntents: ['PAYMENT_AUTHORIZATION'],
                                                allowedPaymentMethods: [
                                                    {
                                                        type: 'CARD',
                                                        parameters: {
                                                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                                            allowedCardNetworks: ['MASTERCARD', 'VISA'],
                                                        },
                                                        tokenizationSpecification: {
                                                            type: 'PAYMENT_GATEWAY',
                                                            parameters: {
                                                                gateway: 'best2pay',
                                                                gatewayMerchantId: process.env.REACT_APP_GOOGLE_PAY_GATEWAY_MERCHANT_ID,
                                                            },
                                                        },
                                                    },
                                                ],
                                                merchantInfo: {
                                                    merchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID,
                                                    merchantName: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_NAME,
                                                },
                                                transactionInfo: {
                                                    totalPriceStatus: 'FINAL',
                                                    totalPriceLabel: 'Итого',
                                                    totalPrice: amount,
                                                    currencyCode: 'RUB',
                                                    countryCode: 'RU',
                                                },
                                                emailRequired: true,
                                            }}
                                            onPaymentAuthorized={res => {
                                                console.log('authorized', res);
                                                return {
                                                    transactionState: 'SUCCESS',
                                                };
                                            }}
                                            onLoadPaymentData={paymentRequest => {
                                                console.log('load payment data', paymentRequest);
                                                this.props.startGooglePay({
                                                    ...paymentRequest.paymentMethodData,
                                                    email: paymentRequest.email,
                                                    id: orderId,
                                                });
                                            }}
                                            onError={err => console.log('on error ', err)}
                                        />
                                        <GooglePayText>
                                          Нажимая на кнопку «Оплатить через Google Pay»,
                                          Вы соглашаетесь с условиями
                                            <a href="https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=googlepaytos&ldl=ru">Пользовательского соглашения</a>
                                        </GooglePayText>
                                    </GooglePayContainer>
                                )}
                            </PayButtonContainer>
                            {blockFrame && <FrameLocker />}
                        </FrameWrapper>
                    )}

                    {isStatus && (
                        <StatusContainer>
                            <StatusTextContainer>
                                <div>
                                    <img src={icon} alt="status icon" />
                                </div>

                                <StatusText dangerouslySetInnerHTML={{ __html: statusText }} />
                            </StatusTextContainer>
                            <StatusSubText>
                                {subText}
                            </StatusSubText>
                            {isLoadedStatus && showRedirectButton && backButtonUrl && (
                                <ButtonOutlined href={backButtonUrl} title="Вернуться на главную" status={status} />
                            )}
                        </StatusContainer>
                    )}

                    <ContentWrapper isStatus={isStatus}>
                        <div>
                            {creditInfoValue && (
                                <CreditInfo
                                    order={order}
                                    status={status}
                                    statusDescriprion={statusDescriprion}
                                    gotStatusPage={gotStatusPage}
                                    isLoadedFrame={isLoadedFrame}
                                    isLoadedStatus={isLoadedStatus}
                                    base
                                />
                            )}
                            {!isStatus && (
                                <CheckboxWrapper>
                                    <CheckboxContainer>
                                        <Checkbox
                                            key={this.state.personalDataProcessing}
                                            name="personalDataProcessing"
                                            label="Я согласен на обработку моих"
                                            link={{ href: '/', text: 'персональных данных ' }}
                                            value={this.state.personalDataProcessing}
                                            onChange={this.setCheckboxValue}
                                            onModalOpen={this.handleModalOpen}
                                            errorOnAgreenment={errorOnAgreenment}
                                        />
                                    </CheckboxContainer>
                                    <CheckboxContainer>
                                        <Checkbox
                                            key={this.state.agreementOnReceivingEmails}
                                            name="agreementOnReceivingEmails"
                                            label="Я согласен на"
                                            link={{ href: '/', text: 'получение информации о продуктах и услугах Банка' }}
                                            value={this.state.agreementOnReceivingEmails}
                                            onChange={this.setCheckboxValue}
                                            onModalOpen={this.handleModalOpen}
                                        />
                                    </CheckboxContainer>
                                </CheckboxWrapper>
                            )}

                            {modal === 'personalDataProcessing' && <ModalPersonalDataProcessing onClose={this.handleModalClose} name="personalDataProcessing" />}
                            {modal === 'agreementOnReceivingEmails' && (
                                <ModalAgreementOnReceivingEmails onClose={this.handleModalClose} name="agreementOnReceivingEmails" />
                            )}
                        </div>
                    </ContentWrapper>
                </MainBox>
                <Footer />
                {googlePayIsLoading && <Loader opacity=".5" />}
            </MainContainer>
        );
    }
}

export default connect(
    state => ({
        frame: state.brand.frame,
        status: state.brand.status,
        site: state.brand.site.data,
        dealerCenter: state.brand.dealerCenter,
        googlePayIsLoading: state.googlePay.googlePayment.isLoading,
        googlePayError: state.googlePay.googlePayment.error,
        consent: state.consent.data,
    }),
    {
        getApplePaySession: getApplePaySessionAction,
        startGooglePay: startGooglePayAction,
        resetConsent: resetConsentAction,
        getConsent: getConsentAction,
        setConsent: setConsentAction,
    },
)(MainBase);
